var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-bar-container"},[_c('div',{staticClass:"progress-bar",style:(_vm.animateProgress ? {} : { width: _vm.progressBarWidth }),attrs:{"id":"progress-bar"}})])}
var staticRenderFns = []

export { render, staticRenderFns }